<template>
  <div class="row justify-content-center">
    <div class="col-md-5">
      <h3 class="text-center">Add category</h3>
      <form @submit.prevent="onFormSubmit">
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control"
            v-model="category.name"
            required
          />
        </div>
        <div class="form-group">
          <label>Type</label>
          <input
            type="text"
            class="form-control"
            v-model="category.type"
            required
          />
        </div>

        <div class="form-group">
          <label>Image</label>
          <input type="file" class="form-control" ref="img" required />
        </div>

        <div class="form-group mt-2">
          <button class="btn btn-primary btn-block"  v-bind:disabled="loading">
            <div class="spinner-border spinner-border-sm" role="status"  v-show="loading"></div>
            Add Category
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { storage, db } from "../firebase";
export default {
  data() {
    return {
      category: {},
      loading : false
    };
  },
  methods: {
    onFormSubmit(event) {
      event.preventDefault();
      this.loading = true;
      //Get path
      var path = `${Date.now()}-${this.$refs.img.files[0].name}`;
      //Get file
      var file = this.$refs.img.files[0];
      //Create a storage ref
      var storageRef = storage.ref(path);
      //Upload file
      storageRef.put(file).then((snapshot) => {
        snapshot.ref.getDownloadURL().then((url) => {
          this.category.img_url = url;
          db.collection("Category")
            .add(this.category)
            .then(() => {
              alert("category successfully created!");
              this.$router.push("/categories");
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            });
        });
      });
    },
  },
};
</script>